function debounce(fn, wait) {
 let t;
 return (...args) => {
  clearTimeout(t);
  t = setTimeout(() => fn.apply(this, args), wait);
 };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
 var data =
  arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
 var detail = {
  detail: data,
 };
 var event = new CustomEvent(eventName, data ? detail : null);
 document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

if (!customElements.get("quantity-selector")) {
 class QuantityInput extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
   this.input = this.querySelector(".qty");
   this.step = parseFloat(this.input.getAttribute("step")) || 1;
   this.changeEvent = new Event("change", { bubbles: true });

   // Create buttons
   this.subtract = this.querySelector(".minus");
   this.add = this.querySelector(".plus");

   // Add functionality to buttons
   this.subtract.addEventListener("click", () =>
    this.changeQuantity(-1 * this.step),
   );
   this.add.addEventListener("click", () => this.changeQuantity(1 * this.step));

   this.classList.add("buttons_added");
   this.validateQtyRules();
  }
  changeQuantity(change) {
   let quantity = parseInt(this.input.value) || 0;

   // Update quantity
   const newValue = Math.max(quantity + change, 1);

   // Check min and max values
   const min = parseInt(this.input.min) || 1;
   const max = parseInt(this.input.max) || Infinity;
   if (newValue < min || newValue > max) return;

   // Update input value
   this.input.value = newValue;

   // Dispatch change event
   this.input.dispatchEvent(this.changeEvent);

   // Update button states
   this.validateQtyRules();
  }

  validateQtyRules() {
   const value = parseInt(this.input.value) || 0;
   const min = parseInt(this.input.min) || 1;
   const max = parseInt(this.input.max) || Infinity;

   this.subtract.classList.toggle("disabled", value <= min);
   this.add.classList.toggle("disabled", value >= max);
  }
 }

 customElements.define("quantity-selector", QuantityInput);
}

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get("product-card")) {
 class ProductCard extends HTMLElement {
  constructor() {
   super();
   this.swatches = this.querySelector(".product-card-swatches");
   this.image = this.querySelector(
    ".product-card-image-link .product-primary-image",
   );
   this.additional_images = this.querySelectorAll(".product-secondary-image");
   this.additional_images_nav = this.querySelectorAll(
    ".product-secondary-images-nav li",
   );
   this.quick_add = this.querySelector(
    ".product-card--add-to-cart-button-simple",
   );
  }
  connectedCallback() {
   if (this.swatches) {
    this.enableSwatches();
   }
   if (this.additional_images) {
    this.enableAdditionalImages();
   }
   if (this.quick_add) {
    this.enableQuickAdd();
   }
  }
  enableAdditionalImages() {
   let image_length = this.additional_images.length;
   let images = this.additional_images;
   let nav = this.additional_images_nav;
   let image_container = this.querySelector(".product-card-image");
   const mousemove = function (e) {
    let l = e.offsetX;
    let w = this.getBoundingClientRect().width;
    let prc = l / w;
    let sel = Math.floor(prc * image_length);
    let selimg = images[sel];
    images.forEach((image, index) => {
     if (image.classList.contains("hover")) {
      image.classList.remove("hover");
      if (nav.length) {
       nav[index].classList.remove("active");
      }
     }
    });
    if (selimg) {
     if (!selimg.classList.contains("hover")) {
      selimg.classList.add("hover");
      if (nav.length) {
       nav[sel].classList.add("active");
      }
     }
    }
   };
   const mouseleave = function (e) {
    images.forEach((image, index) => {
     image.classList.remove("hover");
     if (nav.length) {
      nav[index].classList.remove("active");
     }
    });
   };
   if (image_container) {
    image_container.addEventListener("touchstart", mousemove, {
     passive: true,
    });
    image_container.addEventListener("touchmove", mousemove, {
     passive: true,
    });
    image_container.addEventListener("touchend", mouseleave, {
     passive: true,
    });
    image_container.addEventListener("mouseenter", mousemove, {
     passive: true,
    });
    image_container.addEventListener("mousemove", mousemove, {
     passive: true,
    });
    image_container.addEventListener("mouseleave", mouseleave, {
     passive: true,
    });
   }

   window.addEventListener("load", () => {
    images.forEach(function (image) {
     lazySizes.loader.unveil(image);
    });
   });
  }
  enableSwatches() {
   let swatch_list = this.swatches.querySelectorAll(".product-card-swatch");
   this.color_index = this.swatches.dataset.index;
   this.org_srcset = this.image ? this.image.dataset.srcset : "";

   this.addEventListener("change", this.onSwatchChange.bind(this));

   swatch_list.forEach((swatch) => {
    window.addEventListener("load", () => {
     let image = new Image();
     image.srcset = swatch.dataset.srcset;
     lazySizes.loader.unveil(image);
    });
    swatch.addEventListener("click", this.onSwatchClick);
    swatch.addEventListener("mouseover", this.onSwatchHover);
   });
  }
  onSwatchClick() {
   window.location.href = this.dataset.href;
  }
  onSwatchHover() {
   let swatch_input = this.previousElementSibling;
   swatch_input.checked = true;
   swatch_input.dispatchEvent(new Event("change", { bubbles: true }));
  }
  onSwatchChange(evt) {
   if (this.image) {
    if (evt.target.dataset.srcset) {
     this.image.setAttribute("srcset", evt.target.dataset.srcset);
    } else {
     this.image.setAttribute("srcset", this.org_srcset);
    }
   }
  }
  enableQuickAdd() {
   this.quick_add.addEventListener("click", this.quickAdd.bind(this));
  }
  quickAdd(evt) {
   evt.preventDefault();
   if (this.quick_add.disabled) {
    return;
   }
   this.quick_add.classList.add("loading");
   this.quick_add.setAttribute("aria-disabled", true);

   const config = {
    method: "POST",
    headers: {
     "X-Requested-With": "XMLHttpRequest",
     Accept: "application/javascript",
    },
   };

   let formData = new FormData();

   formData.append("id", this.quick_add.dataset.productId);
   formData.append("quantity", 1);
   formData.append(
    "sections",
    this.getSectionsToRender().map((section) => section.section),
   );
   formData.append("sections_url", window.location.pathname);

   config.body = formData;

   fetch(`${theme.routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
     if (response.status) {
      return;
     }
     this.renderContents(response);
     dispatchCustomEvent("cart:item-added", {
      product: response.hasOwnProperty("items") ? response.items[0] : response,
     });
    })
    .catch((e) => {
     console.error(e);
    })
    .finally(() => {
     this.quick_add.classList.remove("loading");
     this.quick_add.removeAttribute("aria-disabled");
    });

   return false;
  }
  getSectionsToRender() {
   return [
    {
     id: "Cart",
     section: "main-cart",
     selector: ".thb-cart-form",
    },
    {
     id: "Cart-Drawer",
     section: "cart-drawer",
     selector: ".cart-drawer",
    },
    {
     id: "cart-drawer-toggle",
     section: "cart-bubble",
     selector: ".thb-secondary-area--item-count",
    },
    {
     id: "cart-drawer-toggle",
     section: "cart-bubble",
     selector: ".thb-secondary-area--item-amount",
    },
   ];
  }
  renderContents(parsedState) {
   this.getSectionsToRender().forEach((section) => {
    if (!document.getElementById(section.id)) {
     return;
    }
    const elementToReplace =
     document.getElementById(section.id).querySelector(section.selector) ||
     document.getElementById(section.id);
    elementToReplace.innerHTML = this.getSectionInnerHTML(
     parsedState.sections[section.section],
     section.selector,
    );
   });

   if (document.getElementById("Cart-Drawer")) {
    document.getElementById("Cart-Drawer").open();
    document.getElementById("Cart-Drawer").removeProductEvent();
   }
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
   return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector)?.innerHTML;
  }
 }
 customElements.define("product-card", ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get("side-panel-close")) {
 class PanelClose extends HTMLElement {
  constructor() {
   super();
   let cc = document.querySelector(".click-capture");

   // Add functionality to buttons
   this.addEventListener("click", (e) => this.close_panel(e));
   document.addEventListener("panel:close", (e) => {
    let panel = document.querySelectorAll(".side-panel.active");
    if (panel.length) {
     this.close_panel(e, panel[0]);
    }
   });
   cc.addEventListener("click", (e) => {
    let panel = document.querySelectorAll(".side-panel.active");
    if (panel) {
     this.close_panel(e, panel[0]);
    }
   });
  }

  close_panel(e, panel) {
   if (e) {
    e.preventDefault();
   }
   if (!panel) {
    panel = e?.target.closest(".side-panel");

    if (!panel) {
     return;
    }
   }
   panel.classList.remove("active");
   document.body.classList.remove("open-cc");
   panel.setAttribute("inert", "");
  }
 }
 customElements.define("side-panel-close", PanelClose);

 document.addEventListener("keyup", (e) => {
  if (e.code) {
   if (e.code.toUpperCase() === "ESCAPE") {
    dispatchCustomEvent("panel:close");
   }
  }
 });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get("cart-drawer")) {
 class CartDrawer extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
   this.isOpen = false;
   this.button = document.getElementById("cart-drawer-toggle");

   this.debouncedOnChange = debounce((event) => {
    this.onChange(event);
   }, 300);

   document.addEventListener("cart:refresh", (event) => {
    this.refresh();
   });

   this.addEventListener("change", this.debouncedOnChange.bind(this));

   this.removeProductEvent();

   document.addEventListener("click", this.onWindowClick.bind(this));

   // Add functionality to button
   this.button.addEventListener("click", (e) => {
    e.preventDefault();
    this.isOpen ? this.close() : this.open();
   });

   document.addEventListener("keyup", (e) => {
    if (e.code) {
     if (e.code.toUpperCase() === "ESCAPE") {
      this.close();
     }
    }
   });

   // Initialize discount code functionality
   this.initDiscountCode();
  }

  onWindowClick(event) {
   const tabbyDialogContainer = document.querySelector(
    ".styles__dialog--aa402",
   );
   if (
    !this.contains(event.target) &&
    this.isOpen &&
    !this.button.contains(event.target) &&
    !(tabbyDialogContainer && tabbyDialogContainer.contains(event.target))
   ) {
    this.close();
   }
  }
  open() {
   this.removeAttribute("inert");
   this.focus();
   this.isOpen = true;
   dispatchCustomEvent("cart-drawer:open");
   this.customFunctionTrigger();
   this.initDiscountCode();
  }
  customFunctionTrigger() {
   window.initTabbyCartDrawer({
    publicKey: "pk_f979b9b9-b0e9-4f1b-984c-88bd20e8fd12",
   });
  }
  close() {
   this.setAttribute("inert", "");
   this.isOpen = false;
  }
  onChange(event) {
   if (event.target.classList.contains("qty")) {
    this.updateQuantity(event.target.dataset.index, event.target.value);
   }
  }
  removeProductEvent() {
   let removes = this.querySelectorAll(".remove");

   removes.forEach((remove) => {
    remove.addEventListener("click", (event) => {
     this.updateQuantity(event.target.dataset.index, "0");
     event.preventDefault();
    });
   });
  }
  initDiscountCode() {
   // Get discount code elements
   this.discountInput = document.getElementById("cartDrawerDiscountCode");
   this.discountForm = document.getElementById("cartDrawerDiscountForm");
   this.discountButton = document.getElementById("cartDrawerApplyDiscount");
   this.discountStatus = document.getElementById("cartDrawerDiscountStatus");
   this.appliedDiscountContainer = document.getElementById(
    "cartDrawerAppliedDiscount",
   );
   this.appliedDiscountText = this.appliedDiscountContainer?.querySelector(
    ".applied-discount-text",
   );
   this.appliedDiscountRemove = this.appliedDiscountContainer?.querySelector(
    ".applied-discount-remove",
   );

   if (!this.discountInput || !this.discountForm) return;

   // Remove previous event listeners
   if (this._applyDiscountHandler) {
    this.discountForm.removeEventListener("submit", this._applyDiscountHandler);
   }
   if (this.appliedDiscountRemove && this._removeDiscountHandler) {
    this.appliedDiscountRemove.removeEventListener(
     "click",
     this._removeDiscountHandler,
    );
   }

   // Create bound handlers for event listeners
   this._applyDiscountHandler = this.applyDiscount.bind(this);
   this._removeDiscountHandler = this.removeDiscount.bind(this);

   // Add event listeners
   this.discountForm.addEventListener("submit", this._applyDiscountHandler);
   if (this.appliedDiscountRemove) {
    this.appliedDiscountRemove.addEventListener(
     "click",
     this._removeDiscountHandler,
    );
   }

   // Clear the active fetch if it exists
   if (this.activeFetch) {
    this.activeFetch.abort();
    this.activeFetch = null;
   }

   // Check if there's already a discount applied
   this.checkForAppliedDiscount();
  }

  checkForAppliedDiscount() {
   try {
    console.log("Checking for applied discounts...");
    
    // First check for cart-level discount applications in the DOM
    const discountApplications = document.querySelectorAll(
     ".cart-drawer--discount.cart-discount",
    );

    console.log("Found cart-level discount applications:", discountApplications.length);

    if (discountApplications && discountApplications.length > 0) {
     // Get the discount code from the first discount application
     const discountLabel = discountApplications[0].querySelector(
      ".cart-drawer--discount-label",
     );

     if (discountLabel && discountLabel.textContent.trim()) {
      console.log("Found cart-level discount label:", discountLabel.textContent.trim());
      this.showAppliedDiscount(discountLabel.textContent.trim());
      return true;
     }
    }

    // Check for line item discounts
    const lineItemDiscounts = document.querySelectorAll(
     ".product-cart-item .discounts__discount"
    );

    console.log("Found line item discounts:", lineItemDiscounts.length);

    if (lineItemDiscounts && lineItemDiscounts.length > 0) {
     // Get the discount text from the first line item discount
     const discountText = lineItemDiscounts[0].textContent.trim();
     if (discountText) {
      // Extract just the discount name, removing the amount part
      const discountName = discountText.split(' (-')[0].trim();
      console.log("Found line item discount:", discountName);
      this.showAppliedDiscount(discountName);
      return true;
     }
    }

    // Check if the applied discount container already has content from Liquid
    if (this.appliedDiscountText && this.appliedDiscountText.textContent.trim()) {
     console.log("Found pre-populated discount from Liquid:", this.appliedDiscountText.textContent.trim());
     this.appliedDiscountContainer.style.display = "block";
     return true;
    }

    // No discounts found, hide the applied discount container
    console.log("No discounts found, hiding container");
    this.hideAppliedDiscount();
    return false;
   } catch (e) {
    console.error("Error checking for applied discount:", e);
    this.hideAppliedDiscount();
    return false;
   }
  }

  // Returns an array of existing discount codes
  getExistingDiscounts() {
   const discountCodes = [];
   const discountPills = document.querySelectorAll(
    ".cart-drawer--discount.cart-discount",
   );

   discountPills.forEach(pill => {
    const label = pill.querySelector(".cart-drawer--discount-label");
    if (label && label.textContent.trim()) {
     discountCodes.push(label.textContent.trim());
    }
   });

   return discountCodes;
  }

  showAppliedDiscount(code) {
   if (!this.appliedDiscountContainer || !this.appliedDiscountText) {
    console.log("Applied discount elements not found");
    return;
   }

   const displayCode = code && code.trim() ? code : "Discount applied";
   
   console.log("Showing applied discount:", displayCode);
   
   this.discountInput.value = "";
   this.appliedDiscountText.textContent = displayCode;
   this.appliedDiscountContainer.style.display = "block";
   
   // Force visibility and ensure the container is properly displayed
   this.appliedDiscountContainer.style.visibility = "visible";
   this.appliedDiscountContainer.style.opacity = "1";
   
   this.clearDiscountStatus();
  }

  hideAppliedDiscount() {
   if (!this.appliedDiscountContainer) return;

   this.appliedDiscountContainer.style.display = "none";
   if (this.appliedDiscountText) {
    this.appliedDiscountText.textContent = "";
   }
   
   this.clearDiscountStatus();
  }

  clearDiscountStatus() {
   if (this.discountStatus) {
    this.discountStatus.textContent = "";
    this.discountStatus.className = "discount-status";
   }
  }

  createAbortController() {
   if (this.activeFetch) {
    this.activeFetch.abort();
   }

   const abortController = new AbortController();
   this.activeFetch = abortController;
   return abortController;
  }

  applyDiscount(event) {
   if (event) {
    event.preventDefault();
   }

   if (!this.discountInput) return;

   const code = this.discountInput.value.trim();
   if (!code) {
    this.showDiscountError("Please enter a discount code");
    return;
   }

   // Check if code is already applied
   const existingDiscounts = this.getExistingDiscounts();
   if (existingDiscounts.some(discount => discount.toLowerCase() === code.toLowerCase())) {
    this.showDiscountError("This discount code is already applied");
    return;
   }

   // Also check if the code is in the applied discount text
   if (this.appliedDiscountText && this.appliedDiscountText.textContent.toLowerCase() === code.toLowerCase()) {
    this.showDiscountError("This discount code is already applied");
    return;
   }

   // Show loading state
   this.setLoadingState(true);
   this.clearDiscountStatus();

   const abortController = this.createAbortController();

   // Prepare the discount code - append new code to existing codes
   const discountCodesString = [...existingDiscounts, code].join(",");

   const config = {
    method: "POST",
    headers: {
     "Content-Type": "application/json",
     Accept: "application/json",
    },
    body: JSON.stringify({
     discount: discountCodesString,
     sections: this.getSectionsToRender().map((section) => section.section),
     sections_url: window.location.pathname,
    }),
    signal: abortController.signal,
   };

   fetch(theme.routes.cart_update_url, config)
    .then((response) => {
     if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
     }
     return response.json();
    })
    .then((data) => {
     // Check if there's an explicit error in the response
     if (data.errors || data.message) {
      this.showDiscountError("Invalid discount code");
      return;
     }

     // Always render the updated cart
     this.renderSections(data);
     this.discountInput.value = "";
     
     // Validate and show status after rendering
     setTimeout(() => {
      this.checkForAppliedDiscount();
      
      // Simply check if any discount exists now (trust Shopify's processing)
      const hasAnyDiscount = document.querySelectorAll('.cart-drawer--discount.cart-discount').length > 0 ||
                            (this.appliedDiscountText && this.appliedDiscountText.textContent.trim() !== '');
      
      if (hasAnyDiscount) {
       if (this.discountStatus) {
        this.discountStatus.textContent = "Discount applied";
        this.discountStatus.className = "discount-status success";
       }
      } else {
       this.showDiscountError("This discount code is not applicable to your current cart");
      }
     }, 200);
    })
    .catch((error) => {
     if (error.name !== "AbortError") {
      console.error("Error applying discount:", error);
      
      // Don't render sections on error to prevent cart from breaking
      this.showDiscountError("Error applying discount. Please try again.");
      
      // Reset the input value on error
      this.discountInput.value = "";
     }
    })
    .finally(() => {
     this.setLoadingState(false);
    });
  }

  removeDiscount() {
   const appliedCode = this.appliedDiscountText?.textContent;
   if (!appliedCode || !appliedCode.trim()) return;

   this.setLoadingState(true);
   this.clearDiscountStatus();

   const abortController = this.createAbortController();

   const config = {
    method: "POST",
    headers: {
     "Content-Type": "application/json",
     Accept: "application/json",
    },
    body: JSON.stringify({
     discount: "", // Empty string removes all discounts
     sections: this.getSectionsToRender().map((section) => section.section),
     sections_url: window.location.pathname,
    }),
    signal: abortController.signal,
   };

   fetch(theme.routes.cart_update_url, config)
    .then((response) => {
     if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
     }
     return response.json();
    })
    .then((data) => {
     // Check if there's an error in the response
     if (data.errors) {
      this.showDiscountError("Error removing discount");
      return;
     }

     this.renderSections(data);
     this.hideAppliedDiscount();

     if (this.discountStatus) {
      this.discountStatus.textContent = "Discount removed";
      this.discountStatus.className = "discount-status";
     }
    })
    .catch((error) => {
     if (error.name !== "AbortError") {
      console.error("Error removing discount:", error);
      this.showDiscountError("Error removing discount. Please try again.");
     }
    })
    .finally(() => {
     this.setLoadingState(false);
    });
  }

  renderSections(data) {
   if (!data || !data.sections) {
    console.error("Invalid cart update data received");
    return;
   }

   // Store the current state before making changes
   const originalTabbyContainer = document.querySelector('#TabbyPromoCartDrawer');
   const originalTabbyContent = originalTabbyContainer ? originalTabbyContainer.innerHTML : '';

   this.getSectionsToRender().forEach((section) => {
    try {
     const sectionHtml = data.sections[section.section];
     if (sectionHtml) {
      const elementToReplace =
       document.getElementById(section.id)?.querySelector(section.selector) ||
       document.getElementById(section.id);

      if (elementToReplace) {
       elementToReplace.innerHTML = this.getSectionInnerHTML(
        sectionHtml,
        section.selector,
       );
      }
     }
    } catch (error) {
     console.error(`Error updating section ${section.section}:`, error);
    }
   });

   // Re-initialize components after cart update
   this.removeProductEvent();
   this.customFunctionTrigger();
   
   // Re-initialize discount code and check for applied discounts
   setTimeout(() => {
    this.initDiscountCode();
    
    // Restore Tabby if it disappeared
    const currentTabbyContainer = document.querySelector('#TabbyPromoCartDrawer');
    if (currentTabbyContainer && !currentTabbyContainer.innerHTML.trim() && originalTabbyContent) {
     currentTabbyContainer.innerHTML = originalTabbyContent;
    }
   }, 100);
  }

  showDiscountError(message) {
   if (!this.discountStatus) return;

   this.discountStatus.textContent = message;
   this.discountStatus.className = "discount-status error";
   
   // Clear the error after 5 seconds
   setTimeout(() => {
    if (this.discountStatus && this.discountStatus.textContent === message) {
     this.clearDiscountStatus();
    }
   }, 5000);
  }

  setLoadingState(isLoading) {
   if (!this.discountButton) return;

   this.discountButton.disabled = isLoading;
   if (isLoading) {
    this.discountButton.classList.add("loading");
    if (this.discountStatus) {
     this.discountStatus.textContent = "Processing...";
     this.discountStatus.className = "discount-status";
    }
   } else {
    this.discountButton.classList.remove("loading");
    this.activeFetch = null;
   }
  }

  // Debug method to manually trigger discount check
  debugCheckDiscount() {
   console.log("=== Debug Discount Check ===");
   console.log("Applied discount container:", this.appliedDiscountContainer);
   console.log("Applied discount text:", this.appliedDiscountText);
   console.log("Applied discount text content:", this.appliedDiscountText?.textContent);
   console.log("Applied discount remove:", this.appliedDiscountRemove);
   console.log("Container display style:", this.appliedDiscountContainer?.style.display);
   
   const discountApplications = document.querySelectorAll(".cart-drawer--discount.cart-discount");
   console.log("Cart-level discount applications found:", discountApplications);
   
   const lineItemDiscounts = document.querySelectorAll(".product-cart-item .discounts__discount");
   console.log("Line item discounts found:", lineItemDiscounts);
   
   if (discountApplications.length > 0) {
    const label = discountApplications[0].querySelector(".cart-drawer--discount-label");
    console.log("First cart-level discount label:", label?.textContent);
   }
   
   if (lineItemDiscounts.length > 0) {
    console.log("First line item discount text:", lineItemDiscounts[0]?.textContent);
   }
   
   this.checkForAppliedDiscount();
  }

  getSectionsToRender() {
   return [
    {
     id: "Cart-Drawer",
     section: "cart-drawer",
     selector: ".cart-drawer--inner",
    },
    {
     id: "cart-drawer-toggle",
     section: "cart-bubble",
     selector: ".thb-secondary-area--item-count",
    },
    {
     id: "cart-drawer-toggle",
     section: "cart-bubble",
     selector: ".thb-secondary-area--item-amount",
    },
   ];
  }
  getSectionInnerHTML(html, selector) {
   return new DOMParser()
    .parseFromString(html, "text/html")
    .querySelector(selector)?.innerHTML;
  }
  updateQuantity(line, quantity) {
   this.querySelector(`#CartDrawerItem-${line}`)?.classList.add("thb-loading");
   const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
   });

   dispatchCustomEvent("line-item:change:start", {
    quantity: quantity,
   });

   fetch(`${theme.routes.cart_change_url}`, {
    method: "POST",
    headers: {
     "Content-Type": "application/json",
     Accept: `application/json`,
    },
    ...{
     body,
    },
   })
    .then((response) => {
     return response.text();
    })
    .then((state) => {
     const parsedState = JSON.parse(state);

     this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
       document.getElementById(section.id).querySelector(section.selector) ||
       document.getElementById(section.id);

      if (parsedState.sections) {
       elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector,
       );
      }
     });

     this.removeProductEvent();
     this.initDiscountCode(); // Re-initialize discount code after cart update
     dispatchCustomEvent("line-item:change:end", {
      quantity: quantity,
      cart: parsedState,
     });

     this.customFunctionTrigger();

     if (this.querySelector(`#CartDrawerItem-${line}`)) {
      this.querySelector(`#CartDrawerItem-${line}`).classList.remove(
       "thb-loading",
      );
     }
    });
  }
  refresh() {
   let sections = "cart-drawer,cart-bubble";
   fetch(`${window.location.pathname}?sections=${sections}`)
    .then((response) => {
     return response.text();
    })
    .then((state) => {
     const parsedState = JSON.parse(state);

     this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
       document.getElementById(section.id).querySelector(section.selector) ||
       document.getElementById(section.id);

      elementToReplace.innerHTML = this.getSectionInnerHTML(
       parsedState[section.section],
       section.selector,
      );
     });

     this.removeProductEvent();
     this.initDiscountCode(); // Re-initialize discount code after cart refresh
     this.customFunctionTrigger();
    });
  }
 }
 customElements.define("cart-drawer", CartDrawer);
}

/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get("localization-form")) {
 class LocalizationForm extends HTMLElement {
  constructor() {
   super();
   this.form = this.querySelector("form");
   if (!this.form) return;

   this.inputs = this.form.querySelectorAll(
    '[name="locale_code"], [name="country_code"]',
   );
   if (!this.inputs.length) return;

   this.debouncedOnSubmit = debounce((event) => {
    this.onSubmitHandler(event);
   }, 200);

   this.inputs.forEach((item) =>
    item.addEventListener("change", this.debouncedOnSubmit.bind(this)),
   );
  }
  onSubmitHandler(event) {
   if (this.form) this.form.submit();
  }
 }
 customElements.define("localization-form", LocalizationForm);
}

/**
 *  @class
 *  @function ResizeSelect
 */
if (!customElements.get("resize-select")) {
 class ResizeSelect extends HTMLElement {
  constructor() {
   super();
  }

  connectedCallback() {
   this.select = this.querySelector("select");
   this.addEventListeners();
  }
  addEventListeners() {
   this.addEventListener("change", this.resizeSelect.bind(this));
   window.addEventListener("load", this.resizeSelect.bind(this));
   this.resizeSelect();
  }
  resizeSelect() {
   let tempOption = document.createElement("option");
   tempOption.textContent = this.select.selectedOptions[0].textContent;

   let tempSelect = document.createElement("select"),
    offset = 10;
   tempSelect.style.visibility = "hidden";
   tempSelect.style.position = "fixed";
   tempSelect.appendChild(tempOption);
   this.after(tempSelect);
   if (tempSelect.clientWidth > 0) {
    this.select.style.width = `${+tempSelect.clientWidth + offset}px`;
   }
   tempSelect.remove();
  }
 }
 customElements.define("resize-select", ResizeSelect);
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get("quick-view")) {
 class QuickView extends HTMLElement {
  constructor() {
   super();
  }
  connectedCallback() {
   this.drawer = document.getElementById("Product-Modal");
   this.body = document.body;

   this.addEventListener("click", this.setupEventListener.bind(this));
   this.addEventListener("keypress", this.setupEventListener.bind(this));
  }
  setupEventListener(e) {
   if (e.key && e.key !== "Enter") {
    return;
   }
   e.preventDefault();
   let productHandle = this.dataset.productHandle,
    href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

   // remove double `/` in case shop might have /en or language in URL
   href = href.replace("//", "/");
   if (!href || !productHandle) {
    return;
   }
   if (this.classList.contains("loading")) {
    return;
   }
   this.classList.add("loading");
   fetch(href, {
    method: "GET",
   })
    .then((response) => {
     this.classList.remove("loading");
     return response.text();
    })
    .then((text) => {
     const sectionInnerHTML = new DOMParser()
      .parseFromString(text, "text/html")
      .querySelector("#Product-Modal-Content").innerHTML;
     this.renderQuickview(sectionInnerHTML, href, productHandle);
    });
  }
  renderQuickview(sectionInnerHTML, href, productHandle) {
   if (sectionInnerHTML) {
    this.drawer.querySelector("#Product-Modal-Content").innerHTML =
     sectionInnerHTML;

    let js_files = this.drawer
     .querySelector("#Product-Modal-Content")
     .querySelectorAll("script");

    if (js_files.length > 0) {
     var head = document.getElementsByTagName("head")[0];
     js_files.forEach((js_file, i) => {
      let script = document.createElement("script");
      script.src = js_file.src;
      head.appendChild(script);
     });
    }

    setTimeout(() => {
     if (Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
     }
     if (window.ProductModel) {
      window.ProductModel.loadShopifyXR();
     }
    }, 300);

    this.drawer.setAttribute("open", "");
    this.drawer.querySelector(".product-modal__toggle").focus();

    setTimeout(() => {
     let slider = this.drawer.querySelector("#Product-Slider");

     slider.reInit();
     window.dispatchEvent(new Event("resize"));
    }, 100);

    dispatchCustomEvent("quick-view:open", {
     productUrl: href,
     productHandle: productHandle,
    });
    addIdToRecentlyViewed(productHandle);
   }
  }
 }
 customElements.define("quick-view", QuickView);
}

/**
 *  @class
 *  @function ThemeScroll
 */
if (!customElements.get("theme-scroll")) {
 class ThemeScroll extends HTMLElement {
  constructor() {
   super();

   this.viewport = this.querySelector(".theme-scroll--inner");
   this.slideWidth = 274;
   this.slidesToScroll = 1;
  }
  connectedCallback() {
   window.OverlayScrollbarsGlobal.OverlayScrollbars(
    {
     target: this,
     elements: {
      viewport: this.viewport,
     },
    },
    {},
   );

   this.init();
  }
  init() {
   this.setSlides();
   this.reachedEnd = 0;

   if (this.slides.length < 1) {
    return;
   }
   this.nav = this.querySelector(".theme-scroll-nav");
   this.navPrev = this.querySelector(".flickity-prev");
   this.navNext = this.querySelector(".flickity-next");
   this.resizeObserver = new ResizeObserver(
    (entries) => {
     this.slideWidth = this.slides[1].offsetLeft - this.slides[0].offsetLeft;
     this.reachedEnd =
      this.viewport.scrollWidth - this.viewport.offsetWidth ==
      this.viewport.scrollLeft;
     this.onNavDisabled();
    },
    {
     root: this,
    },
   );
   this.debouncedOnScroll = debounce((event) => {
    this.onScroll(event);
   }, 100);

   this.setListeners();
   this.centerArrows();
  }
  setSlides() {
   this.slides = this.querySelectorAll(".carousel__slide");
   this.slidesLength = this.slides.length;
   this.lastSlide = this.slides[this.slides.length - 1];
  }
  setListeners() {
   this.nav.addEventListener("click", this.onNavClick.bind(this));
   this.viewport.addEventListener("scroll", this.debouncedOnScroll.bind(this));
   this.viewport.addEventListener("resize", this.debouncedOnScroll.bind(this));
   this.resizeObserver.observe(this.slides[0]);
  }
  onScroll() {
   this.reachedEnd =
    this.viewport.scrollWidth - this.viewport.offsetWidth ==
    Math.floor(this.viewport.scrollLeft);
   this.onNavDisabled();
  }
  onNavClick(e) {
   if (!e.target.matches(".flickity-nav")) {
    return;
   }
   if (e.target.name === "next") {
    this.scrollPos =
     this.viewport.scrollLeft + this.slidesToScroll * this.slideWidth;
   } else if (e.target.name === "prev") {
    this.scrollPos =
     this.viewport.scrollLeft - this.slidesToScroll * this.slideWidth;
   }
   this.viewport.scrollTo({
    left: this.scrollPos,
    behavior: "smooth",
   });
  }
  onNavDisabled() {
   if (this.navPrev) {
    this.navPrev.disabled = this.viewport.scrollLeft === 0 ? 1 : 0;
   }
   if (this.navNext) {
    this.navNext.disabled = this.reachedEnd ? 1 : 0;
   }
  }
  centerArrows() {
   let first_cell = this.slides[0],
    max_height = 0,
    image_height = 0;
   if (first_cell.querySelector(".product-card-image")) {
    image_height = first_cell.querySelector(".product-card-image").clientHeight;
   } else if (first_cell.querySelector(".gallery--item")) {
    image_height = this.slides[1].querySelector(
     ".product-card-image",
    ).clientHeight;
   }
   if (image_height > 0) {
    this.slides.forEach((item, i) => {
     if (item.clientHeight > max_height) {
      max_height = item.clientHeight;
     }
    });

    if (max_height > image_height) {
     let difference = (max_height - image_height) / -2;

     this.navPrev.style.transform = "translateY(" + difference + "px)";
     this.navNext.style.transform = "translateY(" + difference + "px)";
    }
   }
  }
 }
 customElements.define("theme-scroll", ThemeScroll);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get("collapsible-row")) {
 // https://css-tricks.com/how-to-animate-the-details-element/
 class CollapsibleRow extends HTMLElement {
  constructor() {
   super();

   this.details = this.querySelector("details");
   this.summary = this.querySelector("summary");
   this.content = this.querySelector(".collapsible__content");
   this.collapsed_mobile = this.classList.contains(
    "accordion--collapsed-mobile",
   );

   // Store the animation object (so we can cancel it if needed)
   this.animation = null;
   // Store if the element is closing
   this.isClosing = false;
   // Store if the element is expanding
   this.isExpanding = false;
  }
  connectedCallback() {
   this.setListeners();
  }
  setListeners() {
   if (this.initialized) {
    return;
   }
   this.querySelector("summary").addEventListener("click", (e) =>
    this.onClick(e),
   );

   this.initialized = true;
   if (this.collapsed_mobile) {
    window.addEventListener("resize", () => {
     this.details.open = window.innerWidth > 768;
    });
    window.dispatchEvent(new Event("resize"));
   }
  }
  onClick(e) {
   // Stop default behaviour from the browser
   e.preventDefault();
   // Add an overflow on the <details> to avoid content overflowing
   this.details.style.overflow = "hidden";

   // Check if the element is being closed or is already closed
   if (this.isClosing || !this.details.open) {
    this.open();
    // Check if the element is being openned or is already open
   } else if (this.isExpanding || this.details.open) {
    this.shrink();
   }
  }
  shrink() {
   // Set the element as "being closed"
   this.isClosing = true;

   // Store the current height of the element
   const startHeight = `${this.details.offsetHeight}px`;
   // Calculate the height of the summary
   const endHeight = `${this.summary.offsetHeight}px`;

   // If there is already an animation running
   if (this.animation) {
    // Cancel the current animation
    this.animation.cancel();
   }

   // Start a WAAPI animation
   this.animation = this.details.animate(
    {
     // Set the keyframes from the startHeight to endHeight
     height: [startHeight, endHeight],
    },
    {
     duration: 250,
     easing: "ease",
    },
   );

   // When the animation is complete, call onAnimationFinish()
   this.animation.onfinish = () => this.onAnimationFinish(false);
   // If the animation is cancelled, isClosing variable is set to false
   this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
   // Apply a fixed height on the element
   this.details.style.height = `${this.details.offsetHeight}px`;
   // Force the [open] attribute on the details element
   this.details.open = true;
   // Wait for the next frame to call the expand function
   window.requestAnimationFrame(() => this.expand());
  }

  expand() {
   // Set the element as "being expanding"
   this.isExpanding = true;
   // Get the current fixed height of the element
   const startHeight = `${this.details.offsetHeight}px`;
   // Calculate the open height of the element (summary height + content height)
   const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

   // If there is already an animation running
   if (this.animation) {
    // Cancel the current animation
    this.animation.cancel();
   }

   // Start a WAAPI animation
   this.animation = this.details.animate(
    {
     // Set the keyframes from the startHeight to endHeight
     height: [startHeight, endHeight],
    },
    {
     duration: 250,
     easing: "ease-out",
    },
   );
   // When the animation is complete, call onAnimationFinish()
   this.animation.onfinish = () => this.onAnimationFinish(true);
   // If the animation is cancelled, isExpanding variable is set to false
   this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
   // Set the open attribute based on the parameter
   this.details.open = open;
   // Clear the stored animation
   this.animation = null;
   // Reset isClosing & isExpanding
   this.isClosing = false;
   this.isExpanding = false;
   // Remove the overflow hidden and the fixed height
   this.details.style.height = this.details.style.overflow = "";

   this.dispatchEvent(new Event("animationend", { bubbles: false }));
  }
 }
 customElements.define("collapsible-row", CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {
 if (!handle) {
  let product = document.querySelector(".thb-product-detail");

  if (product) {
   handle = product.dataset.handle;
  }
 }
 if (!handle) {
  return;
 }
 if (window.localStorage) {
  let recentIds = window.localStorage.getItem("recently-viewed");
  if (recentIds && typeof recentIds !== undefined) {
   window.recentlyViewedIds = JSON.parse(recentIds);
  }
 }
 // Remove current product if already in recently viewed array
 var i = window.recentlyViewedIds.indexOf(handle);

 if (i > -1) {
  window.recentlyViewedIds.splice(i, 1);
 }

 // Add id to array
 window.recentlyViewedIds.unshift(handle);

 if (window.localStorage) {
  window.localStorage.setItem(
   "recently-viewed",
   JSON.stringify(window.recentlyViewedIds),
  );
 }
}

document.addEventListener("DOMContentLoaded", () => {
 let scrollbarWidth = window.innerWidth - document.body.clientWidth;
 document.documentElement.style.setProperty(
  "--scrollbar-width",
  scrollbarWidth + "px",
 );
});

// Custom JS
class CartDrawer {
 constructor(drawerSel = ".cart-drawer", buttonSel = "#cart-drawer-cross") {
  this.drawerSel = drawerSel;
  this.buttonSel = buttonSel;
  this.locked = false;

  // Delegate all clicks, catch the close-button whenever it appears
  document.addEventListener("click", this._onDocClick.bind(this), false);
 }

 _onDocClick(e) {
  const btn = e.target.closest(this.buttonSel);
  if (!btn) return;

  e.preventDefault();
  // Look up the drawer right when we need it
  this.drawer = document.querySelector(this.drawerSel);
  if (!this.drawer || typeof this.drawer.close !== "function") return;

  this.close();
 }

 close() {
  if (this.locked) return;
  this.locked = true;

  try {
   const result = this.drawer.close();
   if (result && typeof result.then === "function") {
    result.finally(() => this._reset());
   } else {
    this._reset();
   }
  } catch (err) {
   console.error("CartDrawer close error:", err);
   this._reset();
  }
 }

 _reset() {
  this.locked = false;
 }
}

class TabbyCartDrawer {
 constructor(options = {}) {
  // User-configurable options
  this.promoSelector = options.promoSelector || "#TabbyPromoCartDrawer";
  this.publicKey =
   options.publicKey || "pk_f979b9b9-b0e9-4f1b-984c-88bd20e8fd12";
  this.scriptSrc =
   options.scriptSrc || "https://checkout.tabby.ai/tabby-promo.js";
  this.cartEvents = options.cartEvents || [
   "cart:updated",
   "cart-drawer:updated",
   "cart-drawer:open",
  ];

  // Shopify globals (captured at init/reinit time)
  this.currency = window.Shopify?.currency?.active;
  this.lang = window.Shopify?.locale;

  // Internal state
  this.scriptLoaded = false;
  this.locked = false;
  this.lastTotalCents = null;
 }

 /** Initial setup: load script, render once, bind events */
 async _init() {
  await this._ensureScript();
  await this._refresh();
  this.cartEvents.forEach((evt) =>
   document.addEventListener(evt, () => this._refresh()),
  );
 }

 /**
  * Public re-initializer: merge in any new options,
  * re-fetch Shopify globals, then reload/render if needed
  */
 async reinitialize(newOptions = {}) {
  Object.assign(this, newOptions);
  this.currency = window.Shopify?.currency?.active;
  this.lang = window.Shopify?.locale;
  await this._ensureScript();
  await this._refresh();
 }

 /** Injects the Tabby promo script only once */
 _ensureScript() {
  if (
   this.scriptLoaded ||
   document.querySelector(`script[src="${this.scriptSrc}"]`)
  ) {
   this.scriptLoaded = true;
   return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
   const s = document.createElement("script");
   s.src = this.scriptSrc;
   s.async = true;
   s.onload = () => {
    this.scriptLoaded = true;
    resolve();
   };
   s.onerror = () => reject(new Error(`Failed to load ${this.scriptSrc}`));
   (document.head || document.body).appendChild(s);
  });
 }

 /** Fetch /cart.js, bail if total hasn’t changed, then render TabbyPromo */
 async _refresh() {
  if (this.locked) return;
  this.locked = true;

  let cart;
  try {
   const res = await fetch("/cart.js", { cache: "no-cache" });
   if (!res.ok) throw new Error(`HTTP ${res.status}`);
   cart = await res.json();
  } catch (err) {
   console.error("TabbyCartDrawer fetch error:", err);
   this.locked = false;
   return;
  }

  const totalCents = cart.total_price;
  // Only rerender if the total has changed
  if (totalCents === this.lastTotalCents) {
   this.locked = false;
   return;
  }
  this.lastTotalCents = totalCents;

  if (!totalCents || totalCents <= 0) {
   this.locked = false;
   return;
  }

  const container = document.querySelector(this.promoSelector);
  if (!container) {
   console.warn("TabbyCartDrawer: container not found:", this.promoSelector);
   this.locked = false;
   return;
  }
  container.innerHTML = "";

  // Determine merchantCode from currency
  let merchantCode;
  switch (this.currency) {
   case "AED":
    merchantCode = "default";
    break;
   case "SAR":
    merchantCode = "ksa";
    break;
   case "KWD":
    merchantCode = "KW";
    break;
  }

  const SUPPORTED_CURRENCIES = {
   AED: "AED",
   KWD: "KWD",
   SAR: "SAR",
  };

  // here you can describe count of currency decimals in your store
  const CURRENCY_DIGITS_COUNT = {
   [SUPPORTED_CURRENCIES.AED]: 2,
   [SUPPORTED_CURRENCIES.SAR]: 2,
   [SUPPORTED_CURRENCIES.KWD]: 3,
  };

  // Build and expose config
  const config = {
   selector: this.promoSelector,
   currency: this.currency,
   price:
    totalCents / Number(1 + "0".repeat(CURRENCY_DIGITS_COUNT[this.currency])),
   lang: this.lang,
   installmentsCount: 4,
   publicKey: this.publicKey,
   source: "cart",
   ...(merchantCode && { merchantCode }),
  };
  window.tabbyConfig = config;

  try {
   new TabbyPromo(config);
  } catch (err) {
   console.error("TabbyCartDrawer render error:", err);
  }

  this.locked = false;
 }
}

// Global initializer: creates or reuses a single instance
window.initTabbyCartDrawer = async function (options = {}) {
 if (!window._tabbyCartDrawer) {
  window._tabbyCartDrawer = new TabbyCartDrawer(options);
  await window._tabbyCartDrawer._init();
 } else {
  await window._tabbyCartDrawer.reinitialize(options);
 }
 return window._tabbyCartDrawer;
};

// auto-init on DOM ready
document.addEventListener("DOMContentLoaded", () => {
 new CartDrawer();
 window.initTabbyCartDrawer({
  publicKey: "pk_f979b9b9-b0e9-4f1b-984c-88bd20e8fd12",
 });
});

// Global function to test discount display
window.testDiscountDisplay = function() {
 const cartDrawer = document.querySelector('cart-drawer');
 if (cartDrawer && cartDrawer.debugCheckDiscount) {
  cartDrawer.debugCheckDiscount();
 } else {
  console.log("Cart drawer element not found or debug method not available");
 }
};
